<template>
  <div
    class="beta-banner"
    :style="closeBeta ? 'display: none' : 'display: flex'"
  >
    <p>
      BETA: this is a testing version. Your
      <a href="mailto:dating4Pets@protonmail.com">feedback</a> is valuable and
      well appreciated.
    </p>
    <span @click="closeBetaBanner"><fa icon="times" /></span>
  </div>
  <div class="navbar-container">
    <!-- NAVBAR USED FOR GUESTS -->
    <nav
      class="navbar hidden guest-nav"
      :style="
        isGuest
          ? closeBeta
            ? 'display:flex;top: 0em;'
            : 'display:flex;top: 3em;'
          : 'display:none'
      "
    >
      <router-link to="/">
        <img id="logo-img" src=".././assets/logo.png" alt="Dating4Pets logo" />
      </router-link>
      <Hamburger v-on:click="hamburgerButtonGuest" id="nav-expander" />
      <div class="navbar-content">
        <router-link class="nav-item-router" to="/login">
          <NavItem class="active-page" text="Home" icon="home" />
        </router-link>

        <NavBarAccount />
      </div>
    </nav>
    <div id="nav-close-guest" @click="hamburgerButtonGuest"></div>
    <!-- NAVBAR USED IF THE USER IS LOGGED IN -->
    <nav
      class="navbar hidden user-nav"
      :style="
        !isGuest
          ? closeBeta
            ? 'display:flex;top: 0em;'
            : 'display:flex;top: 3em;'
          : 'display:none'
      "
    >
      <router-link to="/">
        <img id="logo-img" src=".././assets/logo.png" alt="Dating4Pets logo" />
      </router-link>
      <Hamburger v-on:click="hamburgerButton" id="nav-expander" />
      <div class="navbar-content">
        <router-link class="nav-item-router" to="/">
          <NavItem class="active-page" id="home" text="Home" icon="home" />
        </router-link>
        <router-link class="nav-item-router" to="/date">
          <NavItem text="Date" id="date" icon="walking" />
        </router-link>
        <router-link class="nav-item-router" to="/businesses">
          <NavItem text="Care" id="care" icon="hand-holding-heart" />
        </router-link>
        <router-link class="nav-item-router" to="/alert">
          <NavItem text="Alert" id="alert" icon="exclamation-triangle" />
        </router-link>
        <NavBarAccount />
      </div>
    </nav>
    <div id="nav-close-user" @click="hamburgerButton"></div>
  </div>
</template>

<script>
import NavItem from "./NavItem.vue";
import NavBarAccount from "./NavBarAccount.vue";
import Hamburger from "./Hamburger.vue";

export default {
  name: "Navbar",
  components: { NavItem, NavBarAccount, Hamburger },
  methods: {
    hamburgerButtonGuest() {
      let navbar = document.querySelector(".navbar.guest-nav");
      let navContent = navbar.querySelector(".navbar-content");
      let hamCheck = navbar.querySelector("#ham-check");

      let navClose = document.querySelector("#nav-close-guest");

      if (navbar.classList.contains("visible")) {
        navbar.classList.remove("visible");
        navbar.classList.add("hidden");

        hamCheck.checked = false;

        navClose.style.display = "none";

        navContent.classList.remove("full-opacity");
        navContent.classList.add("no-opacity");
      } else {
        navbar.classList.remove("hidden");
        navbar.classList.add("visible");

        hamCheck.checked = true;

        navClose.style.display = "block";

        navContent.classList.remove("no-opacity");
        navContent.classList.add("full-opacity");
      }
    },
    hamburgerButton() {
      let navbar = document.querySelector(".navbar.user-nav");
      let navContent = navbar.querySelector(".navbar-content");
      let hamCheck = navbar.querySelector("#ham-check");

      let navClose = document.querySelector("#nav-close-user");

      if (navbar.classList.contains("visible")) {
        navbar.classList.remove("visible");
        navbar.classList.add("hidden");

        hamCheck.checked = false;

        navClose.style.display = "none";

        navContent.classList.remove("full-opacity");
        navContent.classList.add("no-opacity");
      } else {
        navbar.classList.remove("hidden");
        navbar.classList.add("visible");

        hamCheck.checked = true;

        navClose.style.display = "block";

        navContent.classList.remove("no-opacity");
        navContent.classList.add("full-opacity");
      }
    },
    closeBetaBanner() {
      this.closeBeta = true;
      document.cookie = "closeBeta = true";
    },
  },
  mounted() {
    let self = this;

    let cookies = document.cookie.split(";").map((x) => x.split("="));
    this.closeBeta = cookies.map((a) => a.includes("closeBeta")).includes(true);

    if (localStorage.getItem("jwt") !== null) {
      // KEY EXISTS
      self.isGuest = false;
    } else {
      self.isGuest = true;
    }

    var divs = document.getElementsByTagName("nav-item-router");
    for (var i = 0, len = divs.length; i < len; i++) {
      divs[i].setAttribute("tabindex", "0");
    }

    let currentRoute = self.$router.currentRoute.value.fullPath;
    // console.log(currentRoute);
    // SET ACTIVE PAGE
    let homePage = document.querySelector("#home");
    let datePage = document.querySelector("#date");
    let carePage = document.querySelector("#care");
    let alertPage = document.querySelector("#alert");
    switch (currentRoute) {
      case "/":
        // HOME
        // DEACTIVATE OTHERS
        datePage.classList.remove("active-page");
        carePage.classList.remove("active-page");
        alertPage.classList.remove("active-page");
        // ACTIVATE CURRENT
        homePage.classList.add("active-page");
        break;
      case "/date":
        // MEET
        // DEACTIVATE OTHERS
        homePage.classList.remove("active-page");
        carePage.classList.remove("active-page");
        alertPage.classList.remove("active-page");
        // ACTIVATE CURRENT
        datePage.classList.add("active-page");
        break;
      case "/businesses":
        // MEET
        // DEACTIVATE OTHERS
        homePage.classList.remove("active-page");
        datePage.classList.remove("active-page");
        alertPage.classList.remove("active-page");
        // ACTIVATE CURRENT
        carePage.classList.add("active-page");
        break;
      case "/alert":
        // DEFAULT CASE FOR MEET
        // DEACTIVATE OTHERS
        homePage.classList.remove("active-page");
        datePage.classList.remove("active-page");
        carePage.classList.remove("active-page");
        // ACTIVATE CURRENT
        alertPage.classList.add("active-page");
        break;
      default:
        homePage.classList.remove("active-page");
        datePage.classList.remove("active-page");
        carePage.classList.remove("active-page");
        alertPage.classList.remove("active-page");
        break;
    }
  },
  data() {
    return {
      closeBeta: false,
      isGuest: true,
    };
  },
};
</script>

<style scoped>
.navbar {
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  height: 3rem;
  display: flex;
  justify-content: flex-start;
  background: var(--light-clr);
  box-shadow: 0 0.1rem 2rem hsla(0, 0%, 0%, 0.05);
  z-index: 9000;
  overflow: visible;
}

.navbar-content {
  display: flex;
  align-items: center;
  width: inherit;
  transition: height 0.5s ease;
  padding-inline-start: 3rem;

  /* FOR TESTING */
  overflow: visible;
}

#nav-expander {
  aspect-ratio: 1;
  position: absolute;
  z-index: 9999;
  top: 0;
  right: 0;
  display: none;
}

#logo-img {
  position: absolute;
  min-height: 2rem;
  height: 100%;
  /* max-height: 4rem; */
  max-height: 3rem;
  aspect-ratio: 1;
  cursor: pointer;
  z-index: 9998;
  left: 0;
  top: 0;
}

.active-page {
  --dark-clr: var(--primary-clr);
  box-shadow: inset 0 -0.2rem var(--dark-clr);
  transition: var(--transition);
}

.active-page:hover,
.active-page:focus {
  --dark-clr: var(--mid-dark-clr);
}

.nav-item-router {
  height: 100%;
  /* display: contents; */
  /* color: green; */
  transition: var(--transition);
}

.nav-item-router:focus {
  background: rgba(0, 0, 0, 0.05);
}

#nav-close-guest,
#nav-close-user {
  display: none;
  position: fixed;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  z-index: 8900;
  cursor: pointer;
  top: 0;
  left: 0;
}

/* .hidden + #nav-close-guest,
.hidden + #nav-close-user {
  opacity: 0;
  display: none;
  animation-name: nav-collapse;
  animation-duration: 1s;
} */

.visible + #nav-close-guest,
.visible + #nav-close-user {
  opacity: 1;
  animation-name: nav-expand;
  animation-duration: 0.5s;
}

.beta-banner {
  z-index: 9999;
  width: 100%;
  height: 3em;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--danger);
  background: var(--pending);
  color: var(--light-clr);
}

.beta-banner p {
  color: var(--light-clr);
  margin-inline: 3em;
}

.beta-banner p a {
  text-decoration: underline;
  color: var(--light-clr);
  /* margin-inline-start: 0.3em; */
  transition: var(--transition);
}

.beta-banner p a:hover,
.beta-banner p a:focus {
  color: var(--primary-clr);
  color: var(--dark-clr);
}

.beta-banner span {
  position: absolute;
  right: calc(0em + 1em);
  cursor: pointer;
}

.beta-banner span:hover,
.beta-banner span:focus {
  color: var(--dark-clr);
}

@media screen and (max-width: 25rem) {
  .beta-banner p {
    font-size: 0.6em !important;
  }
}

@media screen and (max-width: 31rem) {
  .navbar {
    /* min-height: 4rem; */
    transition: 0.5s ease-in-out;
    /* height: auto; */
    /* height: 2rem; */
    padding-block-end: 2rem;
    overflow: hidden;
  }

  .navbar.visible {
    transition: 0.9s ease-in-out;
    min-height: 15rem;
    min-height: 20rem;
    max-height: 50vh;
    /* overflow: hidden; */
    overflow: visible;
  }
  .navbar.hidden {
    min-height: 4rem;
  }

  .navbar-content {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    padding-top: 5rem;
    margin-inline-end: 1em;
    overflow: visible;
    opacity: 1;
    transition: var(--transition);
  }

  .full-opacity {
    /* opacity: 100%; */
    animation-name: nav-expand;
    animation-duration: 2s;
  }

  .no-opacity {
    opacity: 0;
  }

  .active-page {
    --dark-clr: var(--primary-clr);
    box-shadow: inset -0.2rem 0 var(--dark-clr) !important;
  }
  #nav-expander {
    display: block;
  }
  /* .user-nav {
    background: red !important;
  }
  .guest-nav {
    background: blue !important;
  } */
  .beta-banner p {
    font-size: 0.8em;
  }
}

@media screen and (max-width: 46rem) {
  .navbar {
    /* min-height: 4rem; */
    transition: 0.5s ease-in-out;
    /* height: auto; */
    /* height: 2rem; */
    padding-block-end: 2rem;
    overflow: hidden;
  }

  .navbar.visible {
    transition: 0.5s ease-in-out;
    min-height: 15rem;
    min-height: 20rem;
    max-height: 50vh;
    /* overflow: hidden; */
    overflow: visible;
  }
  .navbar.hidden {
    min-height: 4rem;
  }

  .navbar-content {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    padding-top: 5rem;
    margin-inline-end: 1em;
    overflow: visible;
    opacity: 1;
    transition: var(--transition);
  }

  .full-opacity {
    /* opacity: 100%; */
    animation-name: nav-expand;
    animation-duration: 0.7s;
  }

  .no-opacity {
    opacity: 0;
  }

  .active-page {
    --dark-clr: var(--primary-clr);
    box-shadow: inset -0.2rem 0 var(--dark-clr) !important;
  }
  #nav-expander {
    display: block;
  }
  /* .user-nav {
    background: red !important;
  }
  .guest-nav {
    background: blue !important;
  } */
}

@media screen and (max-width: 58rem) {
  .navbar {
    /* min-height: 4rem; */
    transition: 0.5s ease-in-out;
    /* height: auto; */
    /* height: 2rem; */
    padding-block-end: 2rem;
    overflow: hidden;
  }

  .navbar.visible {
    transition: 0.9s ease-in-out;
    min-height: 15rem;
    min-height: 20rem;
    max-height: 50vh;
    /* overflow: hidden; */
    overflow: visible;
  }
  .navbar.hidden {
    min-height: 4rem;
  }

  .navbar-content {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    padding-top: 5rem;
    margin-inline-end: 1em;
    overflow: visible;
    opacity: 1;
    transition: var(--transition);
  }

  .full-opacity {
    /* opacity: 100%; */
    animation-name: nav-expand;
    animation-duration: 2s;
  }

  .no-opacity {
    opacity: 0;
  }

  .active-page {
    --dark-clr: var(--primary-clr);
    box-shadow: inset -0.2rem 0 var(--dark-clr) !important;
  }
  #nav-expander {
    display: block;
  }
  /* .user-nav {
    background: red !important;
  }
  .guest-nav {
    background: blue !important;
  } */

  .nav-item-router {
    font-size: 0.95em;
  }
  .nav-item {
    padding: 0.3em;
  }
}

@media screen and (max-width: 66rem) {
  .nav-item-router {
    font-size: 0.9em;
  }
  .nav-item {
    padding: 0.4em;
  }
}
</style>
